export const applicationSpaRoutes = {
  profileIndex: "/profile",
  profileEdit: "/profile/edit",
  profileBookings: "/profile/bookings",
  profileChangePassword: "/profile/change-password",
  consentBorgerDK: "/samtykke-borger-dk",
  createDocument: "/opret-dokument",
  login: "/login",
  notifications: "/notifications",
  myOverview: "/mit-overblik",
  myBookings: "/mine-bookinger",
  myDocuments: "/my-documents",
  identityDocuments: "/identity-documents",
  approveDocument: "/my-documents/approve",
  uploadId: "/upload-id",
  lawdocs: "/lawdocs",
  products: "/produkter",
  getReadyForMeeting: "/bliv-klar-til-møde",
  getReadyForMeetingRequestLink: "/bliv-klar-til-møde/nyt-link",
  meetingPreparation: "/møde-forberedelse",
  myDocumentsPreview: "/dokumenter-til-gennemlæsning",
  myDocumentsPreviewRequestLink: "/dokumenter-til-gennemlæsning/nyt-link",
  completeRegistration: "/complete-registration",
  requestLink: "/request-link",
  digitalOnboarding: "/digital-velkomst",
  campaign: "/kampagne",
  simpleDocumentCreation: {
    futurePow: {
      generalInformation: "/digital-fremtidsfuldmagt-oprettelse",
      grantorInformation: "/digital-fremtidsfuldmagt-oprettelse/fuldmagtsgiver",
      agentsInformation: "/digital-fremtidsfuldmagt-oprettelse/fuldmægtige",
      documentCreationLoading: "/digital-fremtidsfuldmagt-oprettelse/opretter-dokument-indlaesning",
      approveDocument: "/digital-fremtidsfuldmagt-oprettelse/godkend-dokument",
      agentsAgreement: "/digital-fremtidsfuldmagt-oprettelse/fuldmagtshaver-beslutninger",
      customizationSettings: "/digital-fremtidsfuldmagt-oprettelse/tilpasning",
      remuneration: "/digital-fremtidsfuldmagt-oprettelse/gebyrer",
      greaterGifts: "/digital-fremtidsfuldmagt-oprettelse/store-gaver",
    },
    twoFuturePowBundle: {
      generalInformation: "/digital-2-fremtidsfuldmagter-oprettelse",
      grantorInformation: "/digital-2-fremtidsfuldmagter-oprettelse/fuldmagtsgiver",
      agentsInformation: "/digital-2-fremtidsfuldmagter-oprettelse/fuldmægtige",
      documentCreationLoading: "/digital-2-fremtidsfuldmagter-oprettelse/opretter-dokument-indlaesning",
      approveDocument: "/digital-2-fremtidsfuldmagter-oprettelse/godkend-dokument",
      agentsAgreement: "/digital-2-fremtidsfuldmagter-oprettelse/fuldmagtshaver-beslutninger",
      customizationSettings: "/digital-2-fremtidsfuldmagter-oprettelse/tilpasning",
      remuneration: "/digital-2-fremtidsfuldmagter-oprettelse/gebyrer",
      greaterGifts: "/digital-2-fremtidsfuldmagter-oprettelse/store-gaver",
    },
  },
} as const;

// we still need to redirect user to application in order to authenticate.
export const applicationRoutes = { dashboard: "/min-side" } as const;
